import React from 'react';

const Footer = () => {
  return (
  <footer className="h-25 w-full bottom-0 py-10 bg-black text-white text-center ">
  <div className="container mx-auto">
    <h3> Copyright &copy; 2022. All rights reserved.</h3>
  </div>
  </footer>
  );
};

export default Footer;
